import { Col, Row } from "antd";
import React from "react";
import { useFormContext } from "react-hook-form";
import { InputField } from "../../../../../atoms/FormElement";
import {
  getEmailValidationRules,
  getInputPlaceholderMessage,
  getMinMaxValidationRules,
  getValidationProps,
} from "../../../../../libs/form";

export const IndividualTenantDetailsFields = () => {
  const { control, setValue, formState } = useFormContext();

  const { errors } = formState;

  const defaultProps = { control, setValue };

  return (
    <>
      <Row gutter={24}>
        <Col span={8}>
          <InputField
            fieldname="commercial.individual.email"
            label="Email address"
            {...defaultProps}
            {...getValidationProps({
              fieldName: "commercial.individual.email",
              errors,
              isRequired: true,
              rules: getEmailValidationRules(),
            })}
            iProps={{ placeholder: getInputPlaceholderMessage("email address") }}
          />
        </Col>
        <Col span={8}>
          <InputField
            fieldname="commercial.individual.name"
            label="Tenant name"
            {...defaultProps}
            {...getValidationProps({ fieldName: "commercial.individual.name", errors, isRequired: true })}
            iProps={{ placeholder: getInputPlaceholderMessage("tenant name") }}
          />
        </Col>
        <Col span={8}>
          <InputField
            fieldname="commercial.individual.mobile"
            label="Mobile number"
            {...defaultProps}
            {...getValidationProps({
              fieldName: "commercial.individual.mobile",
              errors,
              isRequired: true,
              rules: getMinMaxValidationRules({ label: "Mobile number", min: 9, max: 9 }),
            })}
            iProps={{ addonBefore: "+971", placeholder: "123456789" }}
          />
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={8}>
          <InputField
            isRequired
            fieldname="commercial.individual.designation"
            label="Designation"
            {...defaultProps}
            {...getValidationProps({ fieldName: "commercial.individual.designation", errors, isRequired: true })}
            iProps={{ placeholder: getInputPlaceholderMessage("designation") }}
          />
        </Col>
        <Col span={8}>
          <InputField
            isRequired
            fieldname="commercial.individual.company"
            label="Company"
            {...defaultProps}
            {...getValidationProps({ fieldName: "commercial.individual.company", errors, isRequired: true })}
            iProps={{ placeholder: getInputPlaceholderMessage("company") }}
          />
        </Col>
      </Row>
    </>
  );
};
